import { render, staticRenderFns } from "./Billing-Address-New.vue?vue&type=template&id=789b36a6"
import script from "./Billing-Address-New.vue?vue&type=script&lang=js"
export * from "./Billing-Address-New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports